import * as React from 'react'
import {Box, Button, Typography, CircularProgress} from '@mui/material'


function GradientCircularProgress() {
    return (
      <React.Fragment>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
      </React.Fragment>
    );
  }

export default function InterviewAttemptsButton({attempt, onClick}) {

    return (
        <Box sx={{
            width: '100%',
            height: '20%',
            alignItems: 'center',
            padding: '2%',
        }}>
            <Button 
                data-cy={`attempt${attempt}-button`}
                variant='contained'
                disabled={attempt.processingStatus === 'Processing'}
                onClick={onClick}
                sx={{
                    width: '100%',
                    height: '100%',
                    textTransform: 'none',
                    justifyContent: 'space-between',
                    color: '#CEC9BE',
                    background: '#110A0E',
                    borderRadius: '12px',
                    "&:hover": {
                        backgroundColor: '#404040',
                    },
                    "&.Mui-disabled": {
                        background: '#110A0E',
                        color: '#CEC9BE',
                    }
                }}
            >
                <Box>
                    <Typography variant='h7'>
                        Attempt #{attempt.attemptNumber}
                    </Typography>
                </Box>
                <Box sx={{}}>
                    <Typography variant='h7' sx={{
                        padding: 2,
                        color: attempt.processingStatus === "Processing" ? "#F8A828" :'#87D096'
                    }}>
                        {attempt.processingStatus === "Processing" ? "Processing Submission..." : "Ready For Viewing"}
                    </Typography>
                    {attempt.processingStatus === "Processing" ? <CircularProgress size={30} sx={{color: '#F8A828'}}/> : <></>}
                </Box>
            </Button>
        </Box>
    )
}